import { gql } from '@apollo/client';

export default gql`
  mutation UpdateUser($id: Int!, $userPatch: UserPatch!) {
    updateUserById(input: { id: $id, userPatch: $userPatch }) {
      user {
        id
      }
    }
  }
`;
